import { useEffect, useState } from 'react'
import { app, HostClientType } from '@microsoft/teams-js'

import useIsMobile from '@helpers/hooks/useIsMobile'

const MOBILE_HOSTS: string[] = [HostClientType.android, HostClientType.ios, HostClientType.ipados]

/**
 * Whether the Teams host is the mobile app, whose webview blocks new windows.
 * Asks Teams rather than trusting the user agent: the iPad app reports itself
 * as a Mac. Until Teams answers (and outside Teams) it falls back to the user agent.
 */
const useIsTeamsMobileHost = (): boolean => {
  const isMobileUserAgent = useIsMobile()
  const [clientType, setClientType] = useState<string>()

  useEffect(() => {
    if (!app.isInitialized()) return
    let active = true
    app
      .getContext()
      .then((context) => {
        if (active) setClientType(context.app.host.clientType)
      })
      .catch(() => undefined)
    return () => {
      active = false
    }
  }, [])

  return clientType ? MOBILE_HOSTS.includes(clientType) : isMobileUserAgent
}

export default useIsTeamsMobileHost
